import { Inject } from '@odinjs/odin';

import { Endpoint } from '@philips-emr/hpms-provider-commons';
import { FetchAPI, PaginatorAPI, PanelAPI, TableAPI, TextAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import Controller, { OnClick, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';
import { isEmptyObject } from '@philips-emr/tws-utils';

import { LocatorMedicineMaterialsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface Material {
  cdMaterial: number,
  dsMaterial: string,
  totalCount: number,
  nrSeqMaterialLocator: number,
}

@Controller({ fragment: FragmentNames.LOCATOR_MEDICINE_MATERIALS })
export default class LocatorMedicineMaterialController extends BaseController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext: SubmittableFragmentContext;
  @Inject(Aliases.TABLE)
  private table: TableAPI;
  @Inject(Aliases.PANEL_LOADER)
  private panelLoader: PanelAPI;
  @Inject(Aliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions: PanelAPI;
  @Inject(Aliases.PANEL_PAGINATOR)
  private panelPaginator: PanelAPI;
  @Inject(Aliases.PANEL_MESSAGE)
  private panelMessage: PanelAPI;
  @Inject(Aliases.FETCH_MATERIAL_LOCATOR)
  private fetchMaterialLocator: FetchAPI;
  @Inject(Aliases.TEXT_MESSAGE)
  private textMessage: TextAPI;
  @Inject(Aliases.PAGINATOR)
  private paginator: PaginatorAPI;

  @OnSubmit(Aliases.FILTER_MEDICINE_MATERIALS)
  onSubmit(): void {
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const parameters = this.fetchMaterialLocator.getParameters() as unknown as Material;
    this.panelLoader.setVisible(true);
    this.panelPaginator.setVisible(false);
    this.panelGlobalActions.setVisible(false);
    this.panelMessage.setVisible(false);
    if (!isEmptyObject(parameters)) {
      HttpService.get<Material[]>(Endpoint.GET.FILTER_MATERIALS, { ...parameters, nrSeqAccreditation })
        .then(({ body }) => {
          this.panelLoader.setVisible(false);
          if (body) {
            this.panelPaginator.setVisible(true);
            const { totalCount } = body[0];
            this.paginator.setData(body as unknown as Record<string, Value>[]);
            this.fetchMaterialLocator.setState({ totalCount });
            this.panelGlobalActions.setVisible(true);
          }
        }).catch(({ body }) => {
          this.panelGlobalActions.setVisible(false);
          this.panelLoader.setVisible(false);
          this.panelMessage.setVisible(true);
          this.textMessage.setValue(String(body));
        });
    } else {
      this.panelLoader.setVisible(false);
      this.panelMessage.setVisible(true);
    }
  }

  @OnClick(Aliases.BUTTON_SELECT)
  onClick(): void {
    const [selected] = this.table.getSelectedRows() || [];

    if (!isEmptyObject(selected)) {
      this.submittableFragmentContext.submit(new SubmitEvent({ record: selected }));
    }
  }
}
